import React, { useState, useRef, useEffect } from "react";

import { Document, Page } from 'react-pdf';

import firebase from "../../utils/firebaseConfig"

// import { getFirestore } from "firebase/firestore";
import { SnackbarProvider, useSnackbar } from 'notistack';

import { v4 as uuid } from "uuid";

import { useSelector, useDispatch } from "react-redux";
import { addItem } from "../../actions";

import tableIcons from "../tableFormatting/tableIcons";

import Blank from "../NanoCompTemplates/Blank";
import Default from "../NanoCompTemplates/Default";

import {
    Box,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
    Typography,
} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80vw",
    maxHeight: "90vh",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: "scroll"
  };


const CreateNanoCompModal = ({ isOpen, setIsOpen, listLength }) => {

    const compList = useSelector(state => state.nanoCompDataReducer);
    const compList2 = useSelector(state => state.firebase);

    const auth = useSelector(state => state.firebase);
    const dispatch = useDispatch();

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    const [analysisType, setAnalysisType] = useState("");

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [parent, setParent] = useState("");
    const [parent2, setParent2] = useState("");
    const [child, setChild] = useState("");
    const [child2, setChild2] = useState("");
    const [sub, setSub] = useState("");
    const [sub2, setSub2] = useState("");
    const [templates, setTemplates] = useState([
        {
            index: 0,
            name: "Default",
        },
        {
            index: 1,
            name: "Blank"
        }
    ])
    const [selectedTemplate, setSelectedTemplate] = useState(0);

    const [details, setDetails] = useState([])

    const [modalOpen, setModalOpen] = useState(isOpen);

    const [picture, setPicture] = useState(null);
    const [imgData, setImgData] = useState(null);

    const data = [];
    
    const dateFormatting = { year: 'numeric', month: 'short', day: 'numeric' };


    const onFileUpload = async (e) => {

      const file = e.target.files[0];
      if (file != null) {
        const data = new FormData();
        data.append('file_from_react', file);
    
        let response = await fetch('/api/description',
          {
            method: 'post',
            body: data,
          }
        );
        let res = await response.json();
        console.log(res)
        setName(res.file_name.slice(0, -4))
        setDescription(res.description)
        if (res.status !== 1){
          console.log('Error uploading file');
        }
      }


    };



    const handleOpen = () => {
        setModalOpen(true);
    }
    const handleClose = () => {
        setModalOpen(false);
    }

const onSubmit = () => {


    details.push({
        name: name,
        parent: parent,
        child: child,
        sub: sub,
        template: selectedTemplate,
        description: description
    })
    setDetails(details)
    
    handleClose();

    if(selectedTemplate == 0) {
      console.log("default")
      console.log(Default)


       const dataSet = {
        creationDate: new Date().toLocaleDateString('en-US', dateFormatting),
         
         index: listLength,
         author: auth.auth.uid,
         authorName: auth.auth.displayName,
         likes: 0,
         name: name,
         description: description,
         isExample: false,
         data: [
           {
           name: parent,
           value: Default[0].data[0].value,
           uid: uuid(),
           index: Default[0].data[0].index,
           description: Default[0].data[0].description,
           children: [{
             masterIndex: Default[0].data[0].children[0].masterIndex,
             parentIndex: Default[0].data[0].children[0].parentIndex,
             index: Default[0].data[0].children[0].index,
             name: child,
             description: Default[0].data[0].children[0].description,
             value: Default[0].data[0].children[0].value,
             strength: Default[0].data[0].children[0].strength,
             children: [{
              masterIndex: Default[0].data[0].children[0].children[0].masterIndex,
              parentIndex: Default[0].data[0].children[0].children[0].parentIndex,
              index: Default[0].data[0].children[0].children[0].index,
              name: sub,
              description: Default[0].data[0].children[0].children[0].description,
              value: Default[0].data[0].children[0].children[0].value,
              strength: Default[0].data[0].children[0].children[0].strength,
             }]
            }],
         },
         {
          name: parent2,
          value: Default[0].data[0].value,
          uid: uuid(),
          index: Default[0].data[0].index + 1,
          description: Default[0].data[0].description,
          children: [{
            masterIndex: Default[0].data[0].children[0].masterIndex +1,
            parentIndex: Default[0].data[0].children[0].parentIndex +1,
            index: Default[0].data[0].children[0].index,
            name: child2,
            description: Default[0].data[0].children[0].description,
            value: Default[0].data[0].children[0].value,
            strength: Default[0].data[0].children[0].strength,
            children: [{
             masterIndex: Default[0].data[0].children[0].children[0].masterIndex + 1,
             parentIndex: Default[0].data[0].children[0].children[0].parentIndex + 1,
             index: Default[0].data[0].children[0].children[0].index,
             name: sub2,
             description: Default[0].data[0].children[0].children[0].description,
             value: Default[0].data[0].children[0].children[0].value,
             strength: Default[0].data[0].children[0].children[0].strength,
            }]

          }],

        },
        
        ],
        assignments: Default[0].assignments,

       }

       

       data.push(dataSet)

      dispatch(addItem(data))
     

    } else if (selectedTemplate == 1) {
   

      const dataSet = {
        creationDate: new Date().toLocaleDateString('en-US', dateFormatting),
        index: listLength,
        author: auth.auth.uid,
        authorName: auth.auth.displayName,
        likes: 0,
        name: name,
        description: description,
        isExample: false,
        data: [
          {
          name: parent,
          value: Blank[0].data[0].value,
          uid: uuid(),
          index: Blank[0].data[0].index,
          description: Blank[0].data[0].description,
          children: [{
            masterIndex: Blank[0].data[0].children[0].masterIndex,
            parentIndex: Blank[0].data[0].children[0].parentIndex,
            index: Blank[0].data[0].children[0].index,
            name: child,
            description: Blank[0].data[0].children[0].description,
            value: Blank[0].data[0].children[0].value,
            strength: Blank[0].data[0].children[0].strength,
            children: [{
             masterIndex: Blank[0].data[0].children[0].children[0].masterIndex,
             parentIndex: Blank[0].data[0].children[0].children[0].parentIndex,
             index: Blank[0].data[0].children[0].children[0].index,
             name: sub,
             description: Blank[0].data[0].children[0].children[0].description,
             value: Blank[0].data[0].children[0].children[0].value,
             strength: Blank[0].data[0].children[0].children[0].strength,
            }]

          }]
        },
          {
          name: parent2,
          value: Blank[0].data[0].value,
          uid: uuid(),
          index: Blank[0].data[0].index + 1,
          description: Blank[0].data[0].description,
          children: [{
            masterIndex: Blank[0].data[0].children[0].masterIndex + 1,
            parentIndex: Blank[0].data[0].children[0].parentIndex + 1,
            index: Blank[0].data[0].children[0].index,
            name: child,
            description: Blank[0].data[0].children[0].description,
            value: Blank[0].data[0].children[0].value,
            strength: Blank[0].data[0].children[0].strength,
            children: [{
             masterIndex: Blank[0].data[0].children[0].children[0].masterIndex + 1,
             parentIndex: Blank[0].data[0].children[0].children[0].parentIndex + 1,
             index: Blank[0].data[0].children[0].children[0].index,
             name: sub,
             description: Blank[0].data[0].children[0].children[0].description,
             value: Blank[0].data[0].children[0].children[0].value,
             strength: Blank[0].data[0].children[0].children[0].strength,
            }]

          }]
        },
      ],
      assignments: Blank[0].assignments,


      }



      data.push(dataSet)
 


     dispatch(addItem(data))
    }



    enqueueSnackbar(`${data[0].name} content successfully created!`, { variant: "success" })




}
// console.log(auth)

return (

    <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
     
    <IconButton style={{ position: "absolute", right: "10px", marginTop: "-20px" }} onClick={() => handleClose()}>
    <tableIcons.Close color="primary" />
</IconButton>
        <h2 className="pageHeader3" style={{ textAlign: "center" }}>NanoCompetency creation</h2>


 
            <>
            <Box style={{ display: "flex", justifyContent: "center" }}>
             <Button

component="label"
style={{ display: "flex", justifyContent: "center" }}
>
Upload PDF or DOCX
<input
    type="file"
    className="playerProfilePic_home_title"
    onChange={onFileUpload}
    hidden
/>
</Button>
</Box>

<image url={imgData} />
             <Grid container justify="center"> 
             <div style={{ margin: "10px" }} />
             <TextField fullWidth label="Name" id="fullWidth" value={name} onChange={(e) => { setName(e.target.value) }} />
             <div style={{ margin: "30px" }} />

             <TextField fullWidth label="Description" id="fullWidth" multiline={true} minRows="6" value={description} onChange={(e) => { setDescription(e.target.value) }} />
             <div style={{ margin: "10px" }} />
             </Grid>

             </>

            <>
            {/* <p style={{ textAlign: "center", fontStyle: "italic" }}>...The following inputs to handle creation, whilst no Artificial Intelligence implemented...</p>
            <p style={{ textAlign: "center", fontStyle: "italic" }}>...These could be left as a manual creation option...</p> */}
            <Grid container justify="center"> 
            <div style={{ margin: "10px" }} />
            {/* <TextField fullWidth label="Name" id="fullWidth" onChange={(e) => { setName(e.target.value) }} />
            <div style={{ margin: "30px" }} /> */}
           
            <TextField fullWidth label="Parent node 1" id="fullWidth" onChange={(e) => { setParent(e.target.value) }} />
                    <div style={{ margin: "10px" }} />
                    <TextField fullWidth label="Child nodes" id="fullWidth" onChange={(e) => { setChild(e.target.value) }} />
                    <div style={{ margin: "10px" }} />
                    <TextField fullWidth label="Sub nodes" id="fullWidth" onChange={(e) => { setSub(e.target.value) }} />
                    <div style={{ margin: "10px" }} />


            <TextField fullWidth label="Parent node 2" id="fullWidth" onChange={(e) => { setParent2(e.target.value) }} />
                    <div style={{ margin: "10px" }} />
                    <TextField fullWidth label="Child nodes" id="fullWidth" onChange={(e) => { setChild2(e.target.value) }} />
                    <div style={{ margin: "10px" }} />
                    <TextField fullWidth label="Sub nodes" id="fullWidth" onChange={(e) => { setSub2(e.target.value) }} />
                    <div style={{ margin: "10px" }} />
                   
                    <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Template</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedTemplate}
        // defaultValue={templates[0].name}
          label="Template"
          onChange={(e) => setSelectedTemplate(e.target.value)}
        >
       {templates.map((d, i) => (
              
              <MenuItem value={d.index} key={i}>{d.name}</MenuItem>
                
            ))}
         
        </Select>
      </FormControl>
      </Grid>
         <Button
         onClick={() => setAnalysisType("")}
           variant="outlined"
          //  component="label"
           style={{ float: "left", marginTop: "20px" }}
           >
       Back
       </Button>
         <Button
         onClick={() => onSubmit()}
         variant="outlined"
          //  component="label"
           style={{ float: "right", marginTop: "20px" }}
           >
       Submit
       </Button>
       </>
        

        </Box>
    </Modal>

)
};


export default CreateNanoCompModal